
import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Api } from "../services/api";
import { associado_id, userInfo } from "../services/authHandlers";
import {
  detalhesCredor,
  detalhesGestor,
  getBankInfo,
  getDashboardInfo,
  getDiscountInfo,
  getInfoJuros,
  getInfoMulta,
  getParcelamentoInfo,
  getPCC_ID,
  getPlataformaPagamento,
  getProfileInfo,
  getSMSDataGrafico,
  getSMSInfo,
  getTransationInfo,
  listAllBanks,
  listAllProviders,
  listarRecebivelTipo,
  verifyDatabaseService,
  verifyProviderInfo
} from "../services/infoServices";
import deepEqual from "../utils/deepEqual";
import { localClear } from "../utils/localStorageOps";

const InfoContext = createContext({});

function GeneralInfo({ children }) {
  const navigate = useNavigate()
  const { usuario_id } = userInfo
  const maxMonths = 12;
  //let darkState = (getLocal('darkMode') === 'true')
  const [bankList, setBankList] = useState([]);
  const [providerInfo, setProviderInfo] = useState({
    personal: {},
    // api_externa: {},
    parametros: {},
    plataforma_pagamento: {}
  });
  const [topbarInfo, setTopbarInfo] = useState({
    notificacoes: [],
    providers_lista: []
  });
  const [graficosInfo, setGraficosInfo] = useState({
    comunicacoes: {},
    transacoes: {}
  });
  const [associadoInfo, setAssociadoInfo] = useState({});
  const [dashboardInfo, setDashboardInfo] = useState({
    valores: {},
    comunicacoes: {}
  });

  /* Variáveis de Adimplência */
  const [credorData, setCredorData] = useState(false);
  const [gestorData, setGestorData] = useState(false);
  const [recebivelTipoData, setRecebivelTipoData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [feedbackAmount, setFeedbackAmount] = useState(0);
  /* Variáveis de Adimplência */

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [missingBank, setMissingBank] = useState(false);

  const [viewHigienizadosStatus, setViewHigienizadosStatus] = useState(false);

  // setLocal('logoImage', 'Pague_Direto_Marca-01.png');

  const carregaNotificacoes = async () => {
    const user_id = userInfo.usuario_id
    try {
      const { data } = await Api.get(`notificacoes_credor/listar/${user_id}`)
      return (data.rows)
    } catch (error) {
      // console.log(error.response)
      return null
    }
  }

  const verificaPesquisa = async (associadoInfo) => {
    // console.log('associadoInfo', Object.keys(associadoInfo))
    try {
      const { data } = await Api.get(`/pesquisa/verificar`)
      if (Object.keys(associadoInfo).length > 0) {
        // direto.tech e associados
        if (associadoInfo.usuario.usuario_id === '785fb53a-0bd1-4fcd-b6a7-18e2df5d3200') {
          setShowPopup(false)
        }
        else {
          setShowPopup(true)
        }
      } else {
        setShowPopup(true)
      }
      setFeedbackAmount(Number(data.qtd_pesquisa));
    } catch (error) {
      console.error(error)
    }
  }

  const isEqualHelper = (prev, next) => deepEqual(prev, next) ? prev : next

  const softTimeout = (promise, ms = 3000, onLateResolve) => {
    let timedOut = false

    const timeout = new Promise(resolve =>
      setTimeout(() => {
        timedOut = true
        resolve(undefined)
      }, ms)
    )

    promise.then(result => {
      if (timedOut && onLateResolve) {
        onLateResolve(result)
      }
    }).catch(() => { })

    return Promise.race([promise, timeout])
  }

  useEffect(() => {
    const loadAll = async () => {
      setLoading(true)
      const timeout_lote_requisicoes = 3000

      const requests = {
        personal: softTimeout(verifyProviderInfo(usuario_id), 20000, result => setProviderInfo(prev => isEqualHelper(prev, { ...prev, personal: result }))), // personal tem timeout maior pois as de baixo dependem dela
        associado: softTimeout(getProfileInfo(associado_id), timeout_lote_requisicoes, result => setAssociadoInfo(prev => isEqualHelper(prev, result))),
        transacoes: softTimeout(getTransationInfo(), timeout_lote_requisicoes, result => setGraficosInfo(prev => isEqualHelper(prev, { ...prev, transacoes: result }))),
        dashboard: softTimeout(getDashboardInfo(usuario_id), timeout_lote_requisicoes, result => setDashboardInfo(prev => isEqualHelper(prev, { ...prev, valores: result }))),
        parcelamento: softTimeout(getParcelamentoInfo(), timeout_lote_requisicoes, result => setProviderInfo(prev => isEqualHelper(prev, { ...prev, parametros: { ...prev.parametros, parcelamento: result } }))),
        juros: softTimeout(getInfoJuros(), timeout_lote_requisicoes, result => setProviderInfo(prev => isEqualHelper(prev, { ...prev, parametros: { ...prev.parametros, juros: result } }))),
        multa: softTimeout(getInfoMulta(), timeout_lote_requisicoes, result => setProviderInfo(prev => isEqualHelper(prev, { ...prev, parametros: { ...prev.parametros, multa: result } }))),
        pcc: softTimeout(getPCC_ID(), timeout_lote_requisicoes, result => setProviderInfo(prev => isEqualHelper(prev, { ...prev, parametros: { ...prev.parametros, pcc_info: result } }))),
        bancario: softTimeout(getBankInfo(), timeout_lote_requisicoes, result => setProviderInfo(prev => isEqualHelper(prev, { ...prev, parametros: { ...prev.parametros, bancario: result } }))),
        bancos: softTimeout(listAllBanks(), timeout_lote_requisicoes, result => setBankList(prev => isEqualHelper(prev, result))),
        providers: softTimeout(listAllProviders(), timeout_lote_requisicoes, result => setTopbarInfo(prev => isEqualHelper(prev, { ...prev, providers_lista: result }))),
        plataforma: softTimeout(getPlataformaPagamento(usuario_id), timeout_lote_requisicoes, result => setProviderInfo(prev => isEqualHelper(prev, { ...prev, plataforma_pagamento: result }))),
        notificacoes: softTimeout(carregaNotificacoes(), timeout_lote_requisicoes, result => setTopbarInfo(prev => isEqualHelper(prev, { ...prev, notificacoes: result }))),
        gestor: softTimeout(detalhesGestor(), timeout_lote_requisicoes, result => setGestorData(prev => isEqualHelper(prev, result))),
        higienizado: softTimeout(verifyDatabaseService(usuario_id), timeout_lote_requisicoes, result => setViewHigienizadosStatus(prev => isEqualHelper(prev, result)))
      }

      const results = await Promise.all(Object.values(requests))

      const data = Object.keys(requests).reduce((acc, key, index) => {
        acc[key] = results[index]
        return acc
      }, {})

      const provider_documento = data.personal?.usuario_documento
      const pcc_id = data.pcc?.pcc_id

      verificaPesquisa(data.associado)
      const providerUpdates = {
        ...(data.personal && { personal: data.personal }),
        ...(data.plataforma && { plataforma_pagamento: data.plataforma }),
        parametros: {
          ...(data.parcelamento && { parcelamento: data.parcelamento }),
          ...(data.juros && { juros: data.juros }),
          ...(data.multa && { multa: data.multa }),
          ...(data.pcc && { pcc_info: data.pcc }),
          ...(data.bancario && { bancario: data.bancario })
        }
      }

      const dashboardUpdates = {
        ...(data.dashboard && { valores: data.dashboard })
      }

      const graficoUpdates = {
        ...(data.transacoes && { transacoes: data.transacoes })
      }

      const topbarUpdates = {
        ...(data.providers && { providers_lista: data.providers }),
        ...(data.notificacoes && { notificacoes: data.notificacoes })
      }

      if(data.personal?.usuario_deslogado){
        toast.error("Seu token expirou, faça login novamente")
        localClear();
        navigate('/login');
        window.location.reload()
      }
      console.log(data)
      !data.bancario ? setMissingBank(true) : setMissingBank(false)
      setProviderInfo(prev => isEqualHelper(prev, { ...prev, ...providerUpdates }))
      setDashboardInfo(prev => isEqualHelper(prev, { ...prev, ...dashboardUpdates }))
      setGraficosInfo(prev => isEqualHelper(prev, { ...prev, ...graficoUpdates }))
      setTopbarInfo(prev => isEqualHelper(prev, { ...prev, ...topbarUpdates }))
      setAssociadoInfo(prev => isEqualHelper(prev, data.associado))
      setBankList(prev => isEqualHelper(prev, data.bancos))
      setGestorData(prev => isEqualHelper(prev, data.gestor))
      setViewHigienizadosStatus(prev => isEqualHelper(prev, data.higienizado))

      if (provider_documento) {

        const [
          credor,
          desconto,
          sms,
          smsGrafico
        ] = await Promise.all([
          softTimeout(detalhesCredor(provider_documento), timeout_lote_requisicoes, result => setCredorData(prev => isEqualHelper(prev, result))),
          softTimeout(getDiscountInfo(pcc_id), timeout_lote_requisicoes, result => setProviderInfo(prev => isEqualHelper(prev, { ...prev, parametros: { ...prev.parametros, desconto: result } }))),
          softTimeout(getSMSInfo(provider_documento), timeout_lote_requisicoes, result => setDashboardInfo(prev => isEqualHelper(prev, { ...prev, comunicacoes: result }))),
          softTimeout(getSMSDataGrafico(provider_documento, maxMonths), timeout_lote_requisicoes, result => setGraficosInfo(prev => isEqualHelper(prev, { ...prev, comunicacoes: result })))
        ])

        const adimplencia_credor_id = credor?.credor_id

        credor && setCredorData(prev => isEqualHelper(prev, credor))

        desconto && setProviderInfo(
          prev =>
            isEqualHelper(prev, {
              ...prev,
              parametros: {
                ...prev.parametros,
                desconto
              }
            })
        )
        sms && setDashboardInfo(prev => isEqualHelper(prev, { ...prev, comunicacoes: sms }))
        smsGrafico && setGraficosInfo(prev => isEqualHelper(prev, { ...prev, comunicacoes: smsGrafico }))

        adimplencia_credor_id && listarRecebivelTipo(adimplencia_credor_id)
      }

      setLoading(false)
    }

    loadAll()
  }, [reload])

  return (
    <InfoContext.Provider
      value={{
        dashboardInfo,
        providerInfo,
        associadoInfo,
        graficosInfo,
        topbarInfo,
        setLoading,
        setReload,
        gestorData,
        credorData,
        recebivelTipoData,
        loading,
        bankList,
        missingBank,
        detalhesCredor,
        showPopup,
        setShowPopup,
        feedbackAmount,
        viewHigienizadosStatus
      }}
    >
      {children}
    </InfoContext.Provider>
  )
}

function useInfo() {
  return useContext(InfoContext);
}

export { GeneralInfo, useInfo };

